import { CountUp } from './countup.min.js';

const uspCountEls = document.querySelectorAll('.usp__head__count span');

const observer = new IntersectionObserver(
    (entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const targetCount = entry.target.count;
                const decimalPlaces = entry.target.decimalPlaces;
                const countUp = new CountUp(entry.target, targetCount, {
                    duration: 2,
                    decimal: ',',
                    decimalPlaces: decimalPlaces,
                    separator: '.',
                    useGrouping: targetCount >= 10000,
                });
                countUp.start();
                observer.unobserve(entry.target);
            }
        });
    },
    { threshold: 1 }
);

uspCountEls.forEach((uspCountEl) => {
    const originalText = uspCountEl.innerHTML;
    const dotIndex = originalText.indexOf('.');
    const commaIndex = originalText.indexOf(',');

    let decimalPlaces = 0;
    if (dotIndex !== -1) {
        decimalPlaces = originalText.length - dotIndex - 1;
    } else if (commaIndex !== -1) {
        decimalPlaces = originalText.length - commaIndex - 1;
    }

    const number = parseFloat(originalText);

    if (number > 0) {
        uspCountEl.count = number;
        uspCountEl.decimalPlaces = decimalPlaces;
        uspCountEl.innerHTML = '0';
        observer.observe(uspCountEl);
    }
});
